/* eslint-disable prefer-destructuring */
// https://vitejs.dev/guide/env-and-mode.html#production-replacement
export const REACT_APP_IRE_PLAYER_WIDGET_PART_URL = import.meta.env.REACT_APP_IRE_PLAYER_WIDGET_PART_URL;
export const REACT_APP_IRE_PLAYER_WIDGET_ORIGIN = import.meta.env.REACT_APP_IRE_PLAYER_WIDGET_ORIGIN;
export const REACT_APP_TRAFFIC_MANAGER_ORIGIN = import.meta.env.REACT_APP_TRAFFIC_MANAGER_ORIGIN;
export const REACT_APP_CONFIG_BUCKET = import.meta.env.REACT_APP_CONFIG_BUCKET;
export const REACT_APP_VERSION = import.meta.env.REACT_APP_VERSION;
export const REACT_APP_BACKUP_PLAYLIST_ORIGIN = import.meta.env.REACT_APP_BACKUP_PLAYLIST_ORIGIN;
export const REACT_APP_BUILD_ENV = import.meta.env.REACT_APP_BUILD_ENV;
export const REACT_APP_CONFIG_ENV = import.meta.env.REACT_APP_CONFIG_ENV;
export const REACT_APP_DEFAULT_RESOURCES_DOMAIN = import.meta.env.REACT_APP_DEFAULT_RESOURCES_DOMAIN;
export const REACT_APP_REPLACE_RESOURCES_DOMAIN = import.meta.env.REACT_APP_REPLACE_RESOURCES_DOMAIN;
export const REACT_APP_BUILD_DATE_TIME = import.meta.env.REACT_APP_BUILD_DATE_TIME;
export const REACT_APP_SOCIAL_SHARING_ORIGIN = import.meta.env.REACT_APP_SOCIAL_SHARING_ORIGIN;
export const REACT_APP_AD_SCRIPT_PART_URL = import.meta.env.REACT_APP_AD_SCRIPT_PART_URL;
